<template>
  <div class="d-flex flex-grow-1 flex-column">
    <div class="p-4">
      <div>
        <el-form ref="companyForm" :key="timer" :model="companyForm" :rules="rules">
          <el-row>
            <el-button type="text" @click="openImportDialog">
              <i class="bi bi-box-arrow-in-left text-base" />导入Excel
            </el-button>
            <el-button type="text" @click="importLastData">
              <i class="bi bi-box-arrow-in-left text-base" />导入上次数据
            </el-button>
          </el-row>
          <el-form-item label="填报单位:">
            {{ company.name }}
          </el-form-item>

          <el-form-item label="填报月份:" prop="date">
            <el-date-picker
              v-model="companyForm.date"
              value-format="yyyy-MM"
              type="month"
              placeholder="选择填报月份"
              :picker-options="endDateOpt"
            />
          </el-form-item>
          <el-row>
            <div class="relative shadow-md sm:rounded-lg">
              <table
                class="w-full border-collapse border border-slate-400 text-sm text-center dark:text-gray-400 data-table"
              >
                <tr>
                  <th class="py-1 px-2 border border-slate-300" colspan="5">项目</th>
                  <th class="py-1 px-2 border border-slate-300">合计</th>
                </tr>
                <tr v-for="item in dataItems" :key="item.key">
                  <template v-if="item.parent">
                    <td
                      v-for="(parent,index) in item.parent" :key="index" class="border border-slate-300"
                      :rowspan="parent.rowspan ? parent.rowspan : 1" :colspan="parent.colspan ? parent.colspan : 1"
                    >
                      {{ parent.name }}
                    </td>
                  </template>

                  <td
                    class="border border-slate-300" :rowspan="item.rowspan ? item.rowspan : 1"
                    :colspan="item.colspan ? item.colspan : 1"
                  >
                    {{ item.name }}
                  </td>
                  <td class="border border-slate-300">
                    <el-form-item :prop="item.key">
                      <my-input-number
                        v-model="companyForm[item.key]"
                        :precision="'precision' in item ? item.precision : 2"
                        :min="'min' in item ? item.min : -Infinity"
                        :max="'max' in item ? item.max : Infinity"
                      >
                        <template slot="suffix">{{ item.unit }}</template>
                      </my-input-number>
                    </el-form-item>
                  </td>
                </tr>
              </table>
            </div>
          </el-row>


          <el-form-item class="mt-4">
            <el-button type="primary" :loading="loading" :disabled="dataStatus === 3" @click="onSubmit">
              <template v-if="dataStatus === -1 || dataStatus === 1 || dataStatus === 2">
                上报
              </template>
              <template v-else-if="dataStatus === 0">
                更新
              </template>
              <template v-else-if="dataStatus === 3">
                已确认
              </template>
            </el-button>
            <span v-if="dataStatus === 0 || dataStatus === 3" class="text-red-500 font-bold">已上报</span>
          </el-form-item>
        </el-form>
        <el-dialog title="导入Excel" :visible.sync="visible" :close-on-click-modal="false">
          <div class="text-sm font-semibold text-[#333333] mb-[17px]">
            1.下载导入模版
          </div>
          <el-card>
            <div class="flex justify-between items-center">
              <span class="text-[17px]"><i class="bi bi-file-earmark-excel-fill text-[#1bb954] mr-[10px] text-xl" />导入模板</span>
              <a
                :href="company.internet ? '/template/湖南省小额贷款公司经营月报-网络小贷.xlsx' : '/template/湖南省小额贷款公司经营月报.xlsx'" class="downloadBtn"
                target="_blank"
              >下载</a>
            </div>
          </el-card>
          <div class="text-sm font-semibold text-[#333333] mb-[17px] mt-[30px]">
            2.上传完善后的表格
          </div>
          <el-form>
            <el-form-item>
              <el-upload
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-exceed="handleExceed"
                accept=".xlsx"
                :file-list="fileList"
                action="/upload"
                :limit="1"
                drag
              >
                <i class="el-icon-upload" />
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div slot="tip" class="el-upload__tip">只能上传excel文件，且不超过2Mb</div>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="fileList.length > 0">
              <el-button type="primary" :loading="importBtnLoading" @click="onImport">导入</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import MyInputNumber from '@/components/my-input-number'
import {getLastMonth, dataItems} from '@/utils'
import Layout2 from '../../Shared/Layout2'

export default {
  name: 'CompanyForm',
  components: {MyInputNumber},
  layout: Layout2,
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rate: '',//台账利率
      company: {id:this.user.id, name:this.user.company.name,internet: this.user.company.internet},
      importBtnLoading: false,
      dataItems,
      dataStatus: -1, //未填报
      fileList: [],
      visible: false,
      loading: false,
      companyForm: {},
      timer: Date.now(),
      endDateOpt: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      rules: {
        date: [{required: true, message: '请输入填报月份', trigger: 'blur'}],
      },
    }
  },

  watch: {
    'companyForm.date': function (newVal, oldVal) {
      if (!newVal) {
        return
      }
      // console.log('deptForm.date changed', newVal, oldVal)
      this.onCompanyDateChange()
    },
  },
  mounted() {
    this.companyForm = {
      id: this.company.id,
      date: getLastMonth(),
    }
    if (!this.company.internet) {
      this.dataItems = this.dataItems.slice(0, -4)
    }
    this.dataItems.slice(5).forEach(item => {
      this.rules[item.key] = [{required: true, message: '请输入' + item.name, trigger: 'blur'}]
      // this.form[item.key] = '1'
    })
    this.timer = Date.now()
  },
  methods: {
    importLastData() {
      axios.get('/company/last', {params: {company_id: this.companyForm.id}}).then((res) => {
        if (res.data.status === 1) {
          this.$message.success('导入成功')
          // for (let key in res.data.data) {
          //   this.form[key] = res.data.data[key]
          // }
          this.companyForm = {...this.companyForm, ...res.data.data}
          // console.log(this.companyForm)
          this.timer = Date.now()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    openImportDialog() {
      this.visible = true
      this.fileList = []
    },
    handleRemove(file, fileList) {
      this.fileList = []
    },
    handleExceed(files, fileList) {
      this.$message.warning('请删除原有上传文件后重新上传新文件')
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1)
      // console.log(file, fileList, this.fileList)
    },
    onImport() {
      // console.log(this.fileList)
      this.importBtnLoading = true
      axios.post('/company/import', {
        id: this.fileList[0].response.id,
        name: this.fileList[0].response.name,
      }).then((res) => {
        if (res.data.status === 1) {
          this.visible = false
          this.$message.success('导入成功')
          this.companyForm = {...this.companyForm, ...res.data.data}
          // console.log(this.companyForm)
          this.timer = Date.now()
        } else {
          this.$message.error(res.data.message)
        }
        this.importBtnLoading = false
      }).catch(err => {
        this.importBtnLoading = false
      })
    },
    handleExport() {
      this.exportBtnLoading = true
      axios.get('/dept/export', {params: {dept_id: this.deptForm.id, date: this.deptForm.date}}).then((res) => {
        this.exportBtnLoading = false
        if (res.data.status === 1) {
          window.open(res.data.url)
          // for (let key in res.data.data) {
          //   this.form[key] = res.data.data[key]
          // }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    onCompanyDateChange() {
      axios.get('/company/status', {params: {id: this.companyForm.id, date: this.companyForm.date}}).then((res) => {
        if (res.data.status === 1) {
          this.dataStatus = res.data.data_status
          this.companyForm = {...{id: this.companyForm.id, date: this.companyForm.date}, ...res.data.data}
          // if (res.data.rate !== '') {
          //   if (!this.companyForm.data57) {
          //     this.companyForm.data57 = res.data.rate
          //   }
          //   this.rate = res.data.rate
          // } else {
          //   this.rate = ''
          // }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    async onSubmit() {
      // if (this.rate === '') {
      //   this.$alert('请先上传当月台账')
      //   return false
      // }
      await this.$refs.companyForm.validate(async (valid, obj) => {
        if (valid) {
          // if (this.rate !== '' && this.companyForm.data57 != this.rate) {
          //   await this.$confirm('当前填写贷款平均年化利率与上传台账中利率不一致，是否使用台账中利率替换？', '提示', {
          //     confirmButtonText: '确定',
          //     cancelButtonText: '取消',
          //     type: 'warning',
          //   }).then(() => {
          //     this.companyForm.data57 = this.rate
          //   }).catch(() => {
          //   })
          // }
          this.loading = true
          // let data = {}
          // for (let key in this.companyForm) {
          //   data[key] = String(this.companyForm[key])
          // }
          axios.post('/company', this.companyForm).then((res) => {
            if (res.data.status === 1) {
              this.$message.success('填报成功')
            } else {
              this.$alert(res.data.message)
            }
            this.loading = false
          }).catch(err => {
            this.loading = false
          })

        } else {
          console.log(obj, _.first(obj))
          const keys = _.keys(obj)
          this.$alert(obj[keys[0]][0].message + (keys.length > 1 ? ('等' + keys.length + '个数据') : ''), '请填写数据', {
            confirmButtonText: '确定',
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.data-table .el-form-item:not(.is-error) {
  margin-bottom: 0;
}

::v-deep .el-upload, ::v-deep .el-upload-dragger {
  width: 100%;
}

.downloadBtn {
  display: inline-block;
  width: 81px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border: 1px solid #2196f3;
  border-radius: 32px;
  background-color: #fff;
  font-size: 16px;
  color: #1e88e5;
}
</style>
